import styled from "styled-components/macro";
import themeOptions from "system/styles/themeOptions";
import { FilesViewProps } from "components/atoms/FilesView/types";

export const Container = styled.div<FilesViewProps>``;
export const Img = styled.img<FilesViewProps>`
  margin: ${themeOptions.spacing.xxs};
  max-width: 100%;
`;
